// Text colours that stay readable whatever colour a department or layer is given (WCAG contrast).

function luminance(hex: string): number {
  const v = Number.parseInt(hex.slice(1), 16);
  const lin = (c: number) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * lin((v >> 16) & 255) + 0.7152 * lin((v >> 8) & 255) + 0.0722 * lin(v & 255);
}

const contrast = (a: number, b: number) => (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);

/** Black or white, whichever reads better on a `bg` fill. */
export function inkOn(bg: string): string {
  const l = luminance(bg);
  return contrast(l, 1) >= contrast(l, 0) ? "#ffffff" : "#111111";
}

/** The colour itself as text on white, or near-black when it would be too faint (contrast < 4.5). */
export function readableOnWhite(color: string): string {
  return contrast(luminance(color), 1) >= 4.5 ? color : "#212121";
}
